import {ViewPopup} from '../../../../shared/scripts/ui_popup/ViewPopup'

export class UIMRoomExitConfirmationViewPopup extends ViewPopup {
    constructor(leaveAction: () => void) {
        super({key: 'strings:roomPage.leaveRoom.title'}, {key: 'strings:roomPage.leaveRoom.body'}, leaveAction, () => undefined, false, undefined)
        this.show()
    }
}
